import React from "react";
import Navigation from "./components/Navigation";
import Hero from "./components/Hero";
import About from "./components/About";
// import Work from "./components/Work";
// import Experience from "./components/Experience";
// import Contact from "./components/Contact";

function App() {
  return (
    <div className="bg-white text-primary font-sans">
      <Navigation />
      <Hero />
      <About />
      {/* <Work /> */}
      {/* <Experience /> */}
      {/* <Contact /> */}
    </div>
  );
}

export default App;
